export const queryParams = {
	populate: {
		MainMenuItems: {
			on: {
				'menu.dropdown': {
					populate: {
						menu_options: {
							populate: {
								links: {
									populate: true,
								},
							},
						},
					},
				},
				'menu.menu-item-link': {
					populate: true,
				},
				'menu.menu-button': { populate: true },
			},
		},
	},
};
